import ziggyRoute, { type RouteParams, type Config } from 'ziggy-js';

export function dcaRoute(route: string, parameters: RouteParams<string> | undefined, absolute: boolean|undefined, config: Config|undefined ) {
    let params = parameters ?? {};

    //@ts-ignore
    return ziggyRoute(route, parameters, absolute, config);
}
